import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "s15_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = { class: "form-field-floating reactive active my-4" }
const _hoisted_4 = { class: "form-field-floating reactive active my-4" }
const _hoisted_5 = { class: "form-field-floating reactive active my-4" }
const _hoisted_6 = {
  key: 0,
  class: "text-red"
}
const _hoisted_7 = { class: "form-field-floating reactive active my-4" }
const _hoisted_8 = { class: "s5_mobile px-4" }
const _hoisted_9 = { class: "widget px-7 py-7" }
const _hoisted_10 = { class: "custom-upload-size margin-auto flex mb-8" }

import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG } from '@/utils';
    // @ts-expect-error raison: lib externe mal typée
    import { ref, reactive, onMounted, toRaw } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitFormEditVariantModal',
  setup(__props, { expose: __expose }) {

    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const formData = reactive({
        id: null,
        nom: '',
        montant: 0,
        quantite: 0,
        image: null as any,
        image_preview: '/assets/users/default.png',
    });
    const errors = reactive({
        montant: "",
        quantite: "",
    });
    const produit = reactive({
        id: null,
        nom: '',
        montant: 0,
        quantite: 0,
    });

    async function open(_produit: any, _variant: any) {
        Object.assign(produit, _produit);
        Object.assign(formData, _variant);
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onConfirm() {
        resolvePromise({
            id: formData.id,
            nom: formData.nom,
            montant: formData.montant,
            quantite: formData.quantite,
            images: formData.image ? [formData.image] : [],
            images_previews: formData.image_preview ? [formData.image_preview] : [],
        });
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(false);
        isModalOpen.value = false;
    }

    function onFileImageUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.image_preview = uploadedFile.file_preview;
        formData.image = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!
  const _component_custom_upload_input = _resolveComponent("custom-upload-input")!
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isModalOpen.value,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((isModalOpen).value = $event)),
    classesNames: "modal-lg",
    onClosed: onClose
  }, {
    header: _withCtx(() => [...(_cache[5] || (_cache[5] = [
      _createElementVNode("h4", { class: "font-semibold" }, "Formulaire Variant", -1)
    ]))]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        id: "btn-confirmation-confirm",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onConfirm
      }, "Valider"),
      _createElementVNode("button", {
        id: "btn-confirmation-reject",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onReject
      }, "Annuler")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
              _createTextVNode("Variant produit / Edition "),
              _createElementVNode("span", { class: "text-sm text-grey-500" })
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((produit.nom) = $event)),
                name: "nom_produit",
                id: "nom_produit",
                placeholder: "",
                autocomplete: "off",
                readonly: true
              }, null, 512), [
                [_vModelText, produit.nom]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "nom_produit" }, [
                _createTextVNode("Article "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.nom) = $event)),
                name: "nom",
                id: "nom",
                placeholder: "",
                autocomplete: "off",
                readonly: true
              }, null, 512), [
                [_vModelText, formData.nom]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "nom" }, [
                _createTextVNode("Variant "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_money3, _mergeProps({
                class: "form-input",
                modelValue: formData.montant,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.montant) = $event)),
                name: "montant",
                id: "montant",
                placeholder: ""
              }, _unref(AMOUNT_FORMAT_CONFIG)), null, 16, ["modelValue"]),
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "montant" }, [
                _createTextVNode("Prix unitaire "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (!!errors['montant'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(errors['montant']), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_money3, _mergeProps({
                class: "form-input",
                modelValue: formData.quantite,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.quantite) = $event)),
                name: "quantite",
                id: "quantite",
                placeholder: ""
              }, _unref(INTEGER_FORMAT_CONFIG)), null, 16, ["modelValue"]),
              _cache[9] || (_cache[9] = _createElementVNode("label", { for: "quantite" }, "Stock initial", -1))
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "font-semibold mb-5 text-center" }, [
              _createTextVNode("Image "),
              _createElementVNode("span", { class: "text-sm text-grey-500" })
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_custom_upload_input, {
                id: "image-variant",
                label: "Image",
                type: "IMAGE",
                preview: formData.image_preview,
                onUploaded: onFileImageUploaded
              }, null, 8, ["preview"])
            ])
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clear-both" }, null, -1))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})